exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.userLevelType {\r\n    display: inline;\n}\r\n", ""]);

// exports
